import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Preloader from 'components/shared/Preloader';
import { subscriptionInfoSelector } from 'features/billing/subscription/subscriptionSlice';
import { SubscriptionStatus } from 'features/billing/subscription/subscriptionTypes';

interface PageGuardProps {
  children: React.ReactNode;
}

const NonTrialInactiveSubscriptionPageGuard: React.FC<PageGuardProps> = ({ children }) => {
  const subscriptionInfo = useSelector(subscriptionInfoSelector);

  const isActiveOrTrialing = subscriptionInfo!.status === SubscriptionStatus.Active || subscriptionInfo!.status === SubscriptionStatus.Trialing;

  return (
    <>
      {!subscriptionInfo ? (
        <Preloader />
      ) : isActiveOrTrialing ? (
        <Navigate to={'/'} replace />
      ) : (
        children
      )}
    </>
  );
};

export default NonTrialInactiveSubscriptionPageGuard;
